const myInitObject = {}
export default myInitObject